// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /* Box sizing reset */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border-width: 0; /* Explicitly reset border width */
    border-style: solid; /* Ensure consistent border style */
  }

  /* Basic document-level defaults */
  html {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    font-family: inherit;
  }

  body {
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
    /* border: inherit; */
    border-color: inherit;
    background-color: inherit;
  }

  /* Remove list styles */
  ul,
  ol {
    list-style: none;
  }

  /* Anchor tag reset */
  a {
    text-decoration: inherit;
    color: inherit;
  }

  /* Only lighten existing div borders */
  div,
  input,
  textarea {
    border-color: inherit; /* Prevent forcing borders on all divs */
  }

  /* Lighten borders for divs that already have borders */
  textarea,
  input,
  div[style*='border'] textarea,
  input,
  div[class*='border'] {
    border-color: #ddd !important; /* Lighten existing borders */
  }
*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
}
.vas-fixed {
    position: fixed !important;
}
.vas-absolute {
    position: absolute !important;
}
.vas-relative {
    position: relative !important;
}
.vas-inset-0 {
    inset: 0px !important;
}
.vas-inset-y-0 {
    top: 0px !important;
    bottom: 0px !important;
}
.-vas-top-8 {
    top: -2rem !important;
}
.vas-bottom-\\[-10px\\] {
    bottom: -10px !important;
}
.vas-left-0 {
    left: 0px !important;
}
.vas-left-1\\/2 {
    left: 50% !important;
}
.vas-right-0 {
    right: 0px !important;
}
.vas-right-2 {
    right: 0.5rem !important;
}
.vas-right-4 {
    right: 1rem !important;
}
.vas-right-5 {
    right: 1.25rem !important;
}
.vas-top-0 {
    top: 0px !important;
}
.vas-top-1\\/3 {
    top: 33.333333% !important;
}
.vas-top-2 {
    top: 0.5rem !important;
}
.vas-top-5 {
    top: 1.25rem !important;
}
.\\!vas-z-100000 {
    z-index: 100000 !important;
}
.\\!vas-z-100001 {
    z-index: 100001 !important;
}
.\\!vas-z-100002 {
    z-index: 100002 !important;
}
.\\!vas-z-100050 {
    z-index: 100050 !important;
}
.vas-z-10 {
    z-index: 10 !important;
}
.vas-z-100001 {
    z-index: 100001 !important;
}
.vas-z-100050 {
    z-index: 100050 !important;
}
.vas-m-2 {
    margin: 0.5rem !important;
}
.vas-mx-4 {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
}
.vas-mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}
.vas-my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
}
.\\!vas-mt-0 {
    margin-top: 0px !important;
}
.-vas-mt-px {
    margin-top: -1px !important;
}
.vas-mb-1 {
    margin-bottom: 0.25rem !important;
}
.vas-mb-2 {
    margin-bottom: 0.5rem !important;
}
.vas-mb-3 {
    margin-bottom: 0.75rem !important;
}
.vas-mb-4 {
    margin-bottom: 1rem !important;
}
.vas-mb-8 {
    margin-bottom: 2rem !important;
}
.vas-ml-1 {
    margin-left: 0.25rem !important;
}
.vas-ml-2 {
    margin-left: 0.5rem !important;
}
.vas-mr-2 {
    margin-right: 0.5rem !important;
}
.vas-mt-1 {
    margin-top: 0.25rem !important;
}
.vas-mt-2 {
    margin-top: 0.5rem !important;
}
.vas-mt-3 {
    margin-top: 0.75rem !important;
}
.vas-mt-4 {
    margin-top: 1rem !important;
}
.vas-mt-8 {
    margin-top: 2rem !important;
}
.vas-block {
    display: block !important;
}
.vas-inline-block {
    display: inline-block !important;
}
.vas-inline {
    display: inline !important;
}
.vas-flex {
    display: flex !important;
}
.vas-inline-flex {
    display: inline-flex !important;
}
.vas-grid {
    display: grid !important;
}
.vas-hidden {
    display: none !important;
}
.vas-size-3 {
    width: 0.75rem !important;
    height: 0.75rem !important;
}
.vas-size-4 {
    width: 1rem !important;
    height: 1rem !important;
}
.vas-size-5 {
    width: 1.25rem !important;
    height: 1.25rem !important;
}
.vas-size-6 {
    width: 1.5rem !important;
    height: 1.5rem !important;
}
.vas-size-8 {
    width: 2rem !important;
    height: 2rem !important;
}
.\\!vas-h-12 {
    height: 3rem !important;
}
.\\!vas-h-full {
    height: 100% !important;
}
.vas-h-0 {
    height: 0px !important;
}
.vas-h-10 {
    height: 2.5rem !important;
}
.vas-h-3 {
    height: 0.75rem !important;
}
.vas-h-4 {
    height: 1rem !important;
}
.vas-h-5 {
    height: 1.25rem !important;
}
.vas-h-6 {
    height: 1.5rem !important;
}
.vas-h-64 {
    height: 16rem !important;
}
.vas-h-\\[100px\\] {
    height: 100px !important;
}
.vas-h-auto {
    height: auto !important;
}
.vas-h-full {
    height: 100% !important;
}
.vas-max-h-16 {
    max-height: 4rem !important;
}
.vas-max-h-32 {
    max-height: 8rem !important;
}
.vas-max-h-60 {
    max-height: 15rem !important;
}
.vas-max-h-72 {
    max-height: 18rem !important;
}
.vas-min-h-16 {
    min-height: 4rem !important;
}
.\\!vas-w-12 {
    width: 3rem !important;
}
.\\!vas-w-full {
    width: 100% !important;
}
.vas-w-0 {
    width: 0px !important;
}
.vas-w-0\\.5 {
    width: 0.125rem !important;
}
.vas-w-10 {
    width: 2.5rem !important;
}
.vas-w-20 {
    width: 5rem !important;
}
.vas-w-24 {
    width: 6rem !important;
}
.vas-w-3 {
    width: 0.75rem !important;
}
.vas-w-4 {
    width: 1rem !important;
}
.vas-w-5 {
    width: 1.25rem !important;
}
.vas-w-6 {
    width: 1.5rem !important;
}
.vas-w-64 {
    width: 16rem !important;
}
.vas-w-full {
    width: 100% !important;
}
.vas-min-w-8 {
    min-width: 2rem !important;
}
.vas-min-w-\\[275px\\] {
    min-width: 275px !important;
}
.vas-max-w-lg {
    max-width: 32rem !important;
}
.vas-max-w-md {
    max-width: 28rem !important;
}
.vas-flex-1 {
    flex: 1 1 0% !important;
}
.vas-flex-grow {
    flex-grow: 1 !important;
}
.vas-border-collapse {
    border-collapse: collapse !important;
}
.-vas-translate-x-1\\/2 {
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.vas-transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes vas-spin {
    to {
        transform: rotate(360deg);
    }
}
.vas-animate-spin {
    animation: vas-spin 1s linear infinite !important;
}
.vas-cursor-default {
    cursor: default !important;
}
.vas-cursor-not-allowed {
    cursor: not-allowed !important;
}
.vas-cursor-pointer {
    cursor: pointer !important;
}
.vas-select-none {
    -webkit-user-select: none !important;
            user-select: none !important;
}
.vas-grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.vas-flex-row {
    flex-direction: row !important;
}
.vas-flex-col {
    flex-direction: column !important;
}
.vas-flex-wrap {
    flex-wrap: wrap !important;
}
.vas-items-start {
    align-items: flex-start !important;
}
.vas-items-center {
    align-items: center !important;
}
.vas-justify-end {
    justify-content: flex-end !important;
}
.vas-justify-center {
    justify-content: center !important;
}
.vas-justify-between {
    justify-content: space-between !important;
}
.vas-gap-1 {
    gap: 0.25rem !important;
}
.vas-gap-2 {
    gap: 0.5rem !important;
}
.vas-gap-3 {
    gap: 0.75rem !important;
}
.vas-gap-4 {
    gap: 1rem !important;
}
.vas-gap-6 {
    gap: 1.5rem !important;
}
.vas-gap-8 {
    gap: 2rem !important;
}
.vas-space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.vas-space-y-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.vas-space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.vas-space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.vas-overflow-auto {
    overflow: auto !important;
}
.vas-truncate {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
}
.vas-whitespace-nowrap {
    white-space: nowrap !important;
}
.\\!vas-rounded-md {
    border-radius: 0.375rem !important;
}
.vas-rounded {
    border-radius: 0.25rem !important;
}
.vas-rounded-full {
    border-radius: 9999px !important;
}
.vas-rounded-lg {
    border-radius: 0.5rem !important;
}
.vas-rounded-md {
    border-radius: 0.375rem !important;
}
.vas-rounded-none {
    border-radius: 0px !important;
}
.vas-rounded-vasmodalBorderRadiusBorderRadius {
    border-radius: var(--modalBorderRadius-borderRadius) !important;
}
.vas-rounded-vastypographyAuthLabelBorderRadius {
    border-radius: var(--typography-authLabel-borderRadius) !important;
}
.vas-rounded-xl {
    border-radius: 0.75rem !important;
}
.vas-rounded-l-md {
    border-top-left-radius: 0.375rem !important;
    border-bottom-left-radius: 0.375rem !important;
}
.vas-rounded-r-md {
    border-top-right-radius: 0.375rem !important;
    border-bottom-right-radius: 0.375rem !important;
}
.vas-rounded-t {
    border-top-left-radius: 0.25rem !important;
    border-top-right-radius: 0.25rem !important;
}
.\\!vas-border {
    border-width: 1px !important;
}
.vas-border {
    border-width: 1px !important;
}
.vas-border-2 {
    border-width: 2px !important;
}
.vas-border-b {
    border-bottom-width: 1px !important;
}
.vas-border-b-0 {
    border-bottom-width: 0px !important;
}
.vas-border-b-2 {
    border-bottom-width: 2px !important;
}
.vas-border-b-4 {
    border-bottom-width: 4px !important;
}
.vas-border-l {
    border-left-width: 1px !important;
}
.vas-border-r {
    border-right-width: 1px !important;
}
.vas-border-t-2 {
    border-top-width: 2px !important;
}
.vas-border-dashed {
    border-style: dashed !important;
}
.\\!vas-border-none {
    border-style: none !important;
}
.\\!vas-border-gray-300 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.\\!vas-border-vasDanger {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}
.vas-border-\\[\\#ddd\\] {
    --tw-border-opacity: 1 !important;
    border-color: rgb(221 221 221 / var(--tw-border-opacity)) !important;
}
.vas-border-gray-200 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(229 231 235 / var(--tw-border-opacity)) !important;
}
.vas-border-gray-300 {
    --tw-border-opacity: 1 !important;
    border-color: rgb(209 213 219 / var(--tw-border-opacity)) !important;
}
.vas-border-primary {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}
.vas-border-transparent {
    border-color: transparent !important;
}
.vas-border-vasDanger {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}
.vas-border-b-primary {
    --tw-border-opacity: 1 !important;
    border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}
.\\!vas-bg-blue-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity)) !important;
}
.\\!vas-bg-containerBackground {
    background-color: var(--color-background) !important;
}
.\\!vas-bg-orange-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 247 237 / var(--tw-bg-opacity)) !important;
}
.\\!vas-bg-primary\\/20 {
    background-color: hsl(from var(--color-primary) h s l / 0.2) !important;
}
.\\!vas-bg-purple-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 245 255 / var(--tw-bg-opacity)) !important;
}
.\\!vas-bg-transparent {
    background-color: transparent !important;
}
.\\!vas-bg-white {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.vas-bg-black {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity)) !important;
}
.vas-bg-containerBackground {
    background-color: var(--color-background) !important;
}
.vas-bg-gray-100 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.vas-bg-gray-300 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity)) !important;
}
.vas-bg-gray-400 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity)) !important;
}
.vas-bg-gray-50 {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(249 250 251 / var(--tw-bg-opacity)) !important;
}
.vas-bg-primary {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity)) !important;
}
.vas-bg-primary\\/20 {
    background-color: hsl(from var(--color-primary) h s l / 0.2) !important;
}
.vas-bg-transparent {
    background-color: transparent !important;
}
.vas-bg-vasDanger {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(from var(--color-danger) h s l / var(--tw-bg-opacity)) !important;
}
.vas-bg-vasModalBg {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(from var(--color-modalBg) h s l / var(--tw-bg-opacity)) !important;
}
.vas-bg-vasSecondary {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity)) !important;
}
.vas-bg-vasSuccess {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(from var(--color-success) h s l / var(--tw-bg-opacity)) !important;
}
.vas-bg-white {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.vas-bg-opacity-50 {
    --tw-bg-opacity: 0.5 !important;
}
.\\!vas-p-2 {
    padding: 0.5rem !important;
}
.\\!vas-p-3 {
    padding: 0.75rem !important;
}
.vas-p-0 {
    padding: 0px !important;
}
.vas-p-0\\.5 {
    padding: 0.125rem !important;
}
.vas-p-1 {
    padding: 0.25rem !important;
}
.vas-p-1\\.5 {
    padding: 0.375rem !important;
}
.vas-p-2 {
    padding: 0.5rem !important;
}
.vas-p-3 {
    padding: 0.75rem !important;
}
.vas-p-4 {
    padding: 1rem !important;
}
.vas-p-5 {
    padding: 1.25rem !important;
}
.vas-p-6 {
    padding: 1.5rem !important;
}
.vas-px-1 {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
}
.vas-px-2 {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.vas-px-3 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
}
.vas-px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}
.vas-px-5 {
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
}
.vas-px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
}
.vas-py-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
.vas-py-0\\.5 {
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
}
.vas-py-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
.vas-py-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
.vas-py-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
.vas-pb-4 {
    padding-bottom: 1rem !important;
}
.vas-pb-6 {
    padding-bottom: 1.5rem !important;
}
.vas-pl-10 {
    padding-left: 2.5rem !important;
}
.vas-pl-2 {
    padding-left: 0.5rem !important;
}
.vas-pl-3 {
    padding-left: 0.75rem !important;
}
.vas-pl-4 {
    padding-left: 1rem !important;
}
.vas-pr-1 {
    padding-right: 0.25rem !important;
}
.vas-pr-4 {
    padding-right: 1rem !important;
}
.vas-pt-2 {
    padding-top: 0.5rem !important;
}
.vas-pt-8 {
    padding-top: 2rem !important;
}
.\\!vas-text-center {
    text-align: center !important;
}
.vas-text-center {
    text-align: center !important;
}
.vas-font-fontFamily {
    font-family: var(--fontFamily) !important;
}
.vas-font-sans {
    font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
.vas-text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
}
.vas-text-lg {
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
}
.vas-text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}
.vas-text-vastypographyAuthLabelFontSize {
    font-size: var(--typography-authLabel-fontSize) !important;
}
.vas-text-vastypographyHeadingFontSize {
    font-size: var(--typography-heading-fontSize) !important;
}
.vas-text-vastypographyLabelsFontSize {
    font-size: var(--typography-labels-fontSize) !important;
}
.vas-text-vastypographySubheadingFontSize {
    font-size: var(--typography-subHeading-fontSize) !important;
}
.vas-text-xl {
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
}
.vas-text-xs {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}
.vas-font-bold {
    font-weight: 700 !important;
}
.vas-font-medium {
    font-weight: 500 !important;
}
.vas-font-normal {
    font-weight: 400 !important;
}
.vas-font-semibold {
    font-weight: 600 !important;
}
.vas-font-vastypographyAuthLabelFontWeight {
    font-weight: var(--typography-authLabel-fontWeight) !important;
}
.vas-font-vastypographyHeadingFontWeight {
    font-weight: var(--typography-heading-fontWeight) !important;
}
.vas-font-vastypographyLabelsFontWeight {
    font-weight: var(--typography-labels-fontWeight) !important;
}
.vas-font-vastypographySubheadingFontWeight {
    font-weight: var(--typography-subHeading-fontWeight) !important;
}
.\\!vas-text-black {
    --tw-text-opacity: 1 !important;
    color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!vas-text-gray-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.vas-text-\\[\\#26BBF1\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(38 187 241 / var(--tw-text-opacity)) !important;
}
.vas-text-\\[\\#8E95AA\\] {
    --tw-text-opacity: 1 !important;
    color: rgb(142 149 170 / var(--tw-text-opacity)) !important;
}
.vas-text-blue-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(59 130 246 / var(--tw-text-opacity)) !important;
}
.vas-text-gray-400 {
    --tw-text-opacity: 1 !important;
    color: rgb(156 163 175 / var(--tw-text-opacity)) !important;
}
.vas-text-gray-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}
.vas-text-gray-600 {
    --tw-text-opacity: 1 !important;
    color: rgb(75 85 99 / var(--tw-text-opacity)) !important;
}
.vas-text-gray-700 {
    --tw-text-opacity: 1 !important;
    color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.vas-text-gray-800 {
    --tw-text-opacity: 1 !important;
    color: rgb(31 41 55 / var(--tw-text-opacity)) !important;
}
.vas-text-gray-900 {
    --tw-text-opacity: 1 !important;
    color: rgb(17 24 39 / var(--tw-text-opacity)) !important;
}
.vas-text-primary {
    --tw-text-opacity: 1 !important;
    color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity)) !important;
}
.vas-text-primary\\/20 {
    color: hsl(from var(--color-primary) h s l / 0.2) !important;
}
.vas-text-red-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(239 68 68 / var(--tw-text-opacity)) !important;
}
.vas-text-vasDanger {
    --tw-text-opacity: 1 !important;
    color: hsl(from var(--color-danger) h s l / var(--tw-text-opacity)) !important;
}
.vas-text-vastypographyAuthLabelTextColor {
    color: var(--typography-authLabel-color) !important;
}
.vas-text-vastypographyHeadingTextColor {
    color: var(--typography-heading-color) !important;
}
.vas-text-vastypographyLabelsTextColor {
    color: var(--typography-labels-color) !important;
}
.vas-text-vastypographySubHeadingTextColor {
    color: var(--typography-subHeading-color) !important;
}
.vas-text-white {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.vas-underline {
    text-decoration-line: underline !important;
}
.\\!vas-no-underline {
    text-decoration-line: none !important;
}
.vas-accent-vasAccent {
    accent-color: hsl(from var(--color-accent) h s l / 1) !important;
}
.vas-opacity-0 {
    opacity: 0 !important;
}
.vas-opacity-25 {
    opacity: 0.25 !important;
}
.\\!vas-shadow-none {
    --tw-shadow: 0 0 #0000 !important;
    --tw-shadow-colored: 0 0 #0000 !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.vas-shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.vas-shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.vas-shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.vas-shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.vas-shadow-primary\\/30 {
    --tw-shadow-color: hsl(from var(--color-primary) h s l / 0.3) !important;
    --tw-shadow: var(--tw-shadow-colored) !important;
}
.\\!vas-outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.vas-outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.vas-ring-1 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.vas-ring-2 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.vas-ring-black {
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity)) !important;
}
.vas-ring-primary {
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity)) !important;
}
.vas-ring-vasDanger {
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: hsl(from var(--color-danger) h s l / var(--tw-ring-opacity)) !important;
}
.vas-ring-opacity-5 {
    --tw-ring-opacity: 0.05 !important;
}
.vas-transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.vas-transition-all {
    transition-property: all !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.vas-transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.vas-duration-200 {
    transition-duration: 200ms !important;
}
.vas-ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
/* Custom Scrollbar Styles */
/* Desktop view */
@media (min-width: 899px) {
  ::-webkit-scrollbar {
    width: 8px;
  }
}
/* Mobile view */
@media (max-width: 900px) {
  ::-webkit-scrollbar {
  }
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: #acacac;
  border-radius: 10px;
  border: 2px solid transparent;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #acacac;
}
.horizontal-scroll-container {
  overflow-x: auto;
  scrollbar-width: thin;
  scroll-behavior: smooth;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent; /* Firefox */
}
.scroll-container {
  overflow-y: auto;
  scrollbar-width: thin;
  -ms-overflow-style: auto; /* IE and Edge */
  scrollbar-color: #acacac transparent;
}
/* Firefox */
/* Custom scrollbar for Chrome, Safari and Opera */
.scroll-container::-webkit-scrollbar {
    width: 8px;
  }
.scroll-container::-webkit-scrollbar-track {
    background: transparent;
  }
.scroll-container::-webkit-scrollbar-thumb {
    background-color: #acacac;
    border-radius: 10px;
    border: 2px solid transparent;
  }
.scroll-container::-webkit-scrollbar-thumb:hover {
    background-color: #acacac;
  }
.hover\\:vas-border-gray-400:hover {
    --tw-border-opacity: 1 !important;
    border-color: rgb(156 163 175 / var(--tw-border-opacity)) !important;
}
.hover\\:vas-border-primary:hover {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}
.hover\\:vas-border-b-primary:hover {
    --tw-border-opacity: 1 !important;
    border-bottom-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}
.hover\\:\\!vas-bg-primary\\/20:hover {
    background-color: hsl(from var(--color-primary) h s l / 0.2) !important;
}
.hover\\:\\!vas-bg-vasDanger\\/20:hover {
    background-color: hsl(from var(--color-danger) h s l / 0.2) !important;
}
.hover\\:vas-bg-primary:hover {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(from var(--color-primary) h s l / var(--tw-bg-opacity)) !important;
}
.hover\\:vas-bg-primary\\/20:hover {
    background-color: hsl(from var(--color-primary) h s l / 0.2) !important;
}
.hover\\:vas-bg-primary\\/90:hover {
    background-color: hsl(from var(--color-primary) h s l / 0.9) !important;
}
.hover\\:vas-bg-vasDanger\\/10:hover {
    background-color: hsl(from var(--color-danger) h s l / 0.1) !important;
}
.hover\\:vas-bg-vasDanger\\/20:hover {
    background-color: hsl(from var(--color-danger) h s l / 0.2) !important;
}
.hover\\:vas-bg-vasSecondary:hover {
    --tw-bg-opacity: 1 !important;
    background-color: hsl(from var(--color-secondary) h s l / var(--tw-bg-opacity)) !important;
}
.hover\\:vas-bg-vasSecondary\\/20:hover {
    background-color: hsl(from var(--color-secondary) h s l / 0.2) !important;
}
.hover\\:vas-text-gray-700:hover {
    --tw-text-opacity: 1 !important;
    color: rgb(55 65 81 / var(--tw-text-opacity)) !important;
}
.hover\\:vas-text-primary:hover {
    --tw-text-opacity: 1 !important;
    color: hsl(from var(--color-primary) h s l / var(--tw-text-opacity)) !important;
}
.hover\\:vas-underline:hover {
    text-decoration-line: underline !important;
}
.hover\\:vas-shadow-lg:hover {
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.focus\\:\\!vas-border-2:focus {
    border-width: 2px !important;
}
.focus\\:\\!vas-border-primary:focus {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-primary) h s l / var(--tw-border-opacity)) !important;
}
.focus\\:\\!vas-border-vasDanger:focus {
    --tw-border-opacity: 1 !important;
    border-color: hsl(from var(--color-danger) h s l / var(--tw-border-opacity)) !important;
}
.focus\\:vas-border-sky-200:focus {
    --tw-border-opacity: 1 !important;
    border-color: rgb(186 230 253 / var(--tw-border-opacity)) !important;
}
.focus\\:\\!vas-outline-none:focus {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.focus\\:vas-outline-none:focus {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.focus\\:vas-ring:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.focus\\:vas-ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.focus\\:vas-ring-primary:focus {
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: hsl(from var(--color-primary) h s l / var(--tw-ring-opacity)) !important;
}
.disabled\\:\\!vas-cursor-not-allowed:disabled {
    cursor: not-allowed !important;
}
.disabled\\:vas-cursor-not-allowed:disabled {
    cursor: not-allowed !important;
}
.disabled\\:vas-bg-gray-400:disabled {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(156 163 175 / var(--tw-bg-opacity)) !important;
}
.disabled\\:\\!vas-opacity-50:disabled {
    opacity: 0.5 !important;
}
@media (min-width: 640px) {
    .sm\\:vas-right-\\[-10px\\] {
        right: -10px !important;
    }
    .sm\\:vas-top-\\[-10px\\] {
        top: -10px !important;
    }
    .sm\\:vas-hidden {
        display: none !important;
    }
    .sm\\:vas-h-auto {
        height: auto !important;
    }
    .sm\\:vas-max-h-\\[90vh\\] {
        max-height: 90vh !important;
    }
    .sm\\:vas-max-w-lg {
        max-width: 32rem !important;
    }
    .sm\\:vas-rounded-lg {
        border-radius: 0.5rem !important;
    }
    .sm\\:vas-text-sm {
        font-size: 0.875rem !important;
        line-height: 1.25rem !important;
    }
    .sm\\:vas-shadow-xl {
        --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
        --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
    }
}
@media (min-width: 768px) {
    .md\\:vas-w-auto {
        width: auto !important;
    }
    .md\\:vas-grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
}
@media (min-width: 1024px) {
    .lg\\:vas-max-h-\\[85vh\\] {
        max-height: 85vh !important;
    }
    .lg\\:vas-grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";EAAA,qBAAc;EAAd;;;IAAA,sBAAc;IAAd,SAAc;IAAd,UAAc;IAAd,eAAc,EAAd,kCAAc;IAAd,mBAAc,EAAd,mCAAc;EAAA;;EAAd,kCAAc;EAAd;IAAA,gBAAc;IAAd,8BAAc;IAAd,oBAAc;EAAA;;EAAd;IAAA,iBAAc;IAAd,uBAAc;IAAd,6BAAc;EAAA;;EAAd,oCAAc;EAAd;;IAAA,eAAc;IAAd,cAAc;EAAA;;EAAd,yCAAc;EAAd;;;;IAAA,aAAc;IAAd,qBAAc;IAAd,qBAAc;IAAd,yBAAc;EAAA;;EAAd,uBAAc;EAAd;;IAAA,gBAAc;EAAA;;EAAd,qBAAc;EAAd;IAAA,wBAAc;IAAd,cAAc;EAAA;;EAAd,sCAAc;EAAd;;;IAAA,qBAAc,EAAd,wCAAc;EAAA;;EAAd,uDAAc;EAAd;;;;;IAAA,6BAAc,EAAd,6BAAc;EAAA;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd;AAAc;AAEd;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA,wBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oCAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,iEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2CAAmB;IAAnB;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,0FAAmB;IAAnB,8GAAmB;IAAnB;AAAmB;AAAnB;IAAA,wFAAmB;IAAnB,4GAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,2FAAmB;IAAnB,+GAAmB;IAAnB;AAAmB;AAAnB;IAAA,wEAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2KAAmB;IAAnB,mKAAmB;IAAnB,4LAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,0GAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AA0EnB,4BAA4B;AAC5B,iBAAiB;AACjB;EACE;IACE,UAAU;EACZ;AACF;AAEA,gBAAgB;AAChB;EACE;EACA;AACF;AAEA;EACE,uBAAuB;AACzB;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC,EAAE,YAAY;AACpD;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB,EAAE,gBAAgB;EAC1C,oCAAoC;AAoBtC;AApBwC,YAAY;AAElD,kDAAkD;AAClD;IACE,UAAU;EACZ;AAEA;IACE,uBAAuB;EACzB;AAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;EAC/B;AAEA;IACE,yBAAyB;EAC3B;AAvIF;IAAA,iCAyIA;IAzIA;AAyIA;AAzIA;IAAA,iCAyIA;IAzIA;AAyIA;AAzIA;IAAA,iCAyIA;IAzIA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA,6BAyIA;IAzIA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA,6BAyIA;IAzIA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA,+BAyIA;IAzIA;AAyIA;AAzIA;IAAA,+BAyIA;IAzIA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA,0FAyIA;IAzIA,8GAyIA;IAzIA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA,iCAyIA;IAzIA;AAyIA;AAzIA;IAAA,iCAyIA;IAzIA;AAyIA;AAzIA;IAAA,iCAyIA;IAzIA;AAyIA;AAzIA;IAAA,yCAyIA;IAzIA;AAyIA;AAzIA;IAAA,yCAyIA;IAzIA;AAyIA;AAzIA;IAAA,sHAyIA;IAzIA,oHAyIA;IAzIA;AAyIA;AAzIA;IAAA,sHAyIA;IAzIA,oHAyIA;IAzIA;AAyIA;AAzIA;IAAA,+BAyIA;IAzIA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA,6BAyIA;IAzIA;AAyIA;AAzIA;IAAA;AAyIA;AAzIA;IAAA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;IAzIA;QAAA,8BAyIA;QAzIA;IAyIA;IAzIA;QAAA,2FAyIA;QAzIA,+GAyIA;QAzIA;IAyIA;AAAA;AAzIA;IAAA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;AAAA;AAzIA;IAAA;QAAA;IAyIA;IAzIA;QAAA;IAyIA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  /* Box sizing reset */\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    border-width: 0; /* Explicitly reset border width */\n    border-style: solid; /* Ensure consistent border style */\n  }\n\n  /* Basic document-level defaults */\n  html {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    font-family: inherit;\n  }\n\n  body {\n    min-height: 100vh;\n    scroll-behavior: smooth;\n    text-rendering: optimizeSpeed;\n  }\n\n  /* Make images easier to work with */\n  img,\n  picture {\n    max-width: 100%;\n    display: block;\n  }\n\n  /* Inherit fonts for inputs and buttons */\n  input,\n  button,\n  textarea,\n  select {\n    font: inherit;\n    /* border: inherit; */\n    border-color: inherit;\n    background-color: inherit;\n  }\n\n  /* Remove list styles */\n  ul,\n  ol {\n    list-style: none;\n  }\n\n  /* Anchor tag reset */\n  a {\n    text-decoration: inherit;\n    color: inherit;\n  }\n\n  /* Only lighten existing div borders */\n  div,\n  input,\n  textarea {\n    border-color: inherit; /* Prevent forcing borders on all divs */\n  }\n\n  /* Lighten borders for divs that already have borders */\n  textarea,\n  input,\n  div[style*='border'] textarea,\n  input,\n  div[class*='border'] {\n    border-color: #ddd !important; /* Lighten existing borders */\n  }\n}\n\n/* Custom Scrollbar Styles */\n/* Desktop view */\n@media (min-width: 899px) {\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n}\n\n/* Mobile view */\n@media (max-width: 900px) {\n  ::-webkit-scrollbar {\n  }\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #acacac;\n  border-radius: 10px;\n  border: 2px solid transparent;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #acacac;\n}\n\n.horizontal-scroll-container {\n  overflow-x: auto;\n  scrollbar-width: thin;\n  scroll-behavior: smooth;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n}\n\n.scroll-container {\n  overflow-y: auto;\n  scrollbar-width: thin;\n  -ms-overflow-style: auto; /* IE and Edge */\n  scrollbar-color: #acacac transparent; /* Firefox */\n\n  /* Custom scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #acacac;\n    border-radius: 10px;\n    border: 2px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: #acacac;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
